import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';
import type { TimelineComponentType } from '@unifyapps/defs/blocks/Timeline/types';
import { BlockHelper } from '@unifyapps/carbon/helpers/BlockHelper';
import { DependencyPaths } from '@unifyapps/carbon/no-code/helper/DependencyPaths';

const importTimelineComponent = () =>
  import(
    /* webpackChunkName: "timeline-block" */
    './Timeline'
  );

const Timeline = lazy(importTimelineComponent);

class TimelineBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return Timeline;
  }

  get type(): ComponentTypeUnionType {
    return 'Timeline';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }

  getImplicitDependencies(block: BlockType<TimelineComponentType>) {
    const dataSourceIds = BlockHelper.getDataSourceIds(block);
    const dataSourceId = dataSourceIds.find((id) => block.component.content.data?.includes(id));
    if (!dataSourceId) return;
    const paths = DependencyPaths.dataSource(dataSourceId);

    return [
      {
        id: dataSourceId,
        p: [paths.hasNextPage, paths.isFetchingNextPage],
      },
    ];
  }

  preload() {
    return {
      blockPreload: importTimelineComponent,
    };
  }
}

export default TimelineBlockStateDefinition;
